import Alpine from 'alpinejs';
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import phoneInput from "./phone-input";
import { eventsCarousel } from "./carousel";
import { calendarGrid } from "./calendar-grid";
import { categoryListing } from "./category-listing";

Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.plugin(collapse);

Alpine.data("phoneInput", phoneInput);
Alpine.data("eventsCarousel", eventsCarousel);
Alpine.data("calendarGrid", calendarGrid);
Alpine.data("categoryListing", categoryListing);

window.Alpine = Alpine;
Alpine.start();
